import React, { useState } from "react";
import "./chip.scss";

import { useDispatch } from "react-redux";
import {
  fetchRoomsRequest,
  fetchRoomsSuccess,
  fetchRoomsFailure,
  editRoomRequest,
  editRoomSuccess,
  editRoomFailure,
  deleteRoomRequest,
  deleteRoomSuccess,
  deleteRoomFailure,
} from "../../redux/actions";
import axios from "axios";

const Chip = ({ reference, room, order, ...props }) => {
  const [edit, setEdit] = useState(false);
  const [title, setTitle] = useState(room.title);
  const [placeholder, setPlaceholder] = useState(false);

  const dispatch = useDispatch();

  const submit = async () => {
    setEdit(false);

    // FETCH ROOMS
    dispatch(editRoomRequest());
    axios
      .put(`/api/v1/rooms/edit/${room._id}`, { title })
      .then((res) => dispatch(editRoomSuccess(res.data)))
      .catch((err) => dispatch(editRoomFailure(err)))
      .finally(() => fetchRooms());
  };

  const deleteRoom = async () => {
    // FETCH ROOMS
    dispatch(deleteRoomRequest());
    axios
      .delete(`/api/v1/rooms/room/${room._id}`)
      .then((res) => dispatch(deleteRoomSuccess(res.data)))
      .catch((err) => dispatch(deleteRoomFailure(err)))
      .finally(() => fetchRooms());
  };

  const fetchRooms = async () => {
    // FETCH ROOMS
    dispatch(fetchRoomsRequest());
    axios
      .get("/api/v1/rooms")
      .then((res) => dispatch(fetchRoomsSuccess(res.data)))
      .catch((err) => dispatch(fetchRoomsFailure(err)));
  };

  return (
    <React.Fragment>
      <figure ref={reference} className='chip' {...props}>
        {!edit ? (
          <span className='chip__text mr-2'>{room.title}</span>
        ) : (
          <input
            type='text'
            className='chip__input'
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder='Raumname'
          />
        )}
        {!edit ? (
          <span
            className={`icon icon--pencil ml-3 chip__action--edit`}
            onClick={() => setEdit(true)}
          ></span>
        ) : (
          <span
            className={`icon icon--check ml-3 chip__action--edit`}
            onClick={() => submit()}
          ></span>
        )}
        <span
          className='icon icon--bin ml-2 chip__action--delete'
          onClick={() => deleteRoom()}
        ></span>
      </figure>
      {placeholder && (
        <figure className='chip--ph'>
          <span className='chip__text mr-2'></span>
        </figure>
      )}
    </React.Fragment>
  );
};

export default Chip;
